module.exports = require('./helpers/bundle-url').getBundleURL('gnRNX') + "07rates.e9645d7d.png" + "?" + Date.now();